<template>
  <div class="reviews-summary-inline">
    <span class="reviews-summary-inline__rating">
      {{ rating | fixed_number(1) }}
    </span>
    <star-rating
      :rating="rating"
      :increment="0.1"
      :round-start-rating="false"
      :show-rating="false"
      read-only
      :star-size="starSize"
    />
    <span class="reviews-summary-inline__count">
      ({{ total }})
    </span>
  </div>
</template>

<script>
import StarRating from 'vue-star-rating';

export default {
  name: 'ReviewsSummaryInline',
  components: {
    StarRating,
  },
  props: {
    rating: {
      type: Number,
      default: 0,
    },
    total: {
      type: Number,
      default: 0,
    },
    starSize: {
      type: Number,
      default: 18,
    },
  },
};
</script>

<style scoped>
.reviews-summary-inline {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.reviews-summary-inline__rating {
  font-weight: 700;
}

.reviews-summary-inline__count {
  color: #6b7280;
  font-size: 0.875rem;
}
</style>
